import PropTypes from 'prop-types';
export const descriptionWithCtaPropTypes = {
  description: PropTypes.string,
  buttons: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    href: PropTypes.string,
    caption: PropTypes.string
  }))
};